/**
 * What a daily series adds up to from its start through `throughKey`
 * (YYYY-MM-DD, inclusive) — the figure "ahead by / behind by" has to be
 * measured with.
 *
 * The pace says where the period should be by the end of TODAY, so the amount
 * it is held against must also stop at today. For Total Revenue the two are the
 * same thing, because nothing scores after today. Total Scheduled Revenue is
 * the exception: it holds work booked for the days still to come, so its
 * period total ($140k) sat against five days of pace ($100k) and read "Ahead by
 * $40k" — future bookings counted as progress already made.
 *
 * @param {{date:string, value:number}[]} series
 * @param {string|null} throughKey  null = no bound, add the whole series
 */
export default function amountThrough(series, throughKey) {
  return (series || []).reduce((sum, d) => (
    !throughKey || (d && d.date <= throughKey) ? sum + (Number(d && d.value) || 0) : sum
  ), 0);
}
